import { logOut } from "@/services/auth.service"
import { Box, CardMedia, Dialog, LinearProgress, Typography } from "@mui/material"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import imageSrc from '@/assets/images/mallSymbol.png'
import LoadingImg from '@/assets/images/spaceSymbol.png'

export default function Logout() {
    const navigate = useNavigate()
    const { search } = useLocation()
    const referer = search.split('=')[1]
    useEffect(() => {
        (async () => {
            try {
                await logOut().then(r => {
                    console.log('logout result:::::', r)
                    return r
                })
            } catch (e) {
                console.log('logout error:::', e)
                throw e
            } finally {
                if (referer) navigate(referer, { replace: true })
                else navigate(-1)
            }
        })()
    }, [])
    return (
        <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'center'}
            alignItems={'center'}
            height={'300px'}
            width={'100%'}
        >
            {LoadingImg && (<CardMedia component="img" src={LoadingImg} sx={{ width: '200px' }} />)}
            <Typography marginTop={'2rem'} variant="h1" color={'gray'}><b>로그아웃 중입니다...</b></Typography>
        </Box>
    )
}